import React, { useEffect, useState } from 'react';

export const FilterContext = React.createContext();

export const FilterProvider = ({ children }) => {
    const [ searchString, setSearchString ] = useState('');
    const [ classFilter, setClassFilter ] = useState(null);
    const [ schoolFilter, setSchoolFilter ] = useState(null);
    const [ saveFilter, setSaveFilter ] = useState(null);
    const [ levelFilter, setLevelFilter ] = useState([]);
    const [ sourceFilter, setSourceFilter ] = useState([]);
    const [ damageTypeFilter, setDamageTypeFilter ] = useState([]);
    const [ componentFilter, setComponentFilter ] = useState({positive: [], negative: []});
    const [ tagFilter, setTagFilter ] = useState({positive: [], negative: []});
    const [ attackFilter, setAttackFilter ] = useState(null);
    const [ castingTimeFilter, setCastingTimeFilter ] = useState(null);
    const [ activeCount, setActiveCount ] = useState(0);

    useEffect(() => {
        setActiveCount(
            (!!classFilter ? 1 : 0)
             + (!!schoolFilter ? 1 : 0)
             + (!!saveFilter ? 1 : 0)
             + (!!attackFilter ? 1 : 0)
             + (!!castingTimeFilter ? 1 : 0)
             + (levelFilter.length)
             + (sourceFilter.length)
             + (damageTypeFilter.length)
             + (componentFilter?.positive.length)
             + (componentFilter?.negative.length)
             + (tagFilter?.positive.length)
             + (tagFilter?.negative.length)
        );
    }, [attackFilter, classFilter, schoolFilter, saveFilter, levelFilter, sourceFilter, componentFilter, tagFilter, damageTypeFilter, castingTimeFilter]);

    const clearFilters = () => {
        setClassFilter(null);
        setSchoolFilter(null);
        setSaveFilter(null);
        setAttackFilter(null);
        setCastingTimeFilter(null);
        setLevelFilter([]);
        setSourceFilter([]);
        setDamageTypeFilter([]);
        setComponentFilter({positive: [], negative: []});
        setTagFilter({positive: [], negative: []});
        setActiveCount(0);
    };

    return (
        <FilterContext.Provider value={{ 
            searchString, setSearchString,
            classFilter, setClassFilter, 
            saveFilter, setSaveFilter,
            schoolFilter, setSchoolFilter, 
            levelFilter, setLevelFilter,
            sourceFilter, setSourceFilter,
            componentFilter, setComponentFilter,
            tagFilter, setTagFilter,
            damageTypeFilter, setDamageTypeFilter,
            attackFilter, setAttackFilter,
            castingTimeFilter, setCastingTimeFilter,
            activeCount, clearFilters
         }}>
             {children}
        </FilterContext.Provider>
    );
};
